module.exports = __webpack_public_path__ + "static/media/info.f22cbfec.svg";